import { useSiteContent } from '../../../hooks/useSiteContent';

export default function PortfolioSection() {
  const { content, loading } = useSiteContent();

  if (loading || !content) {
    return (
      <section id="portfolio" className="py-20 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-blue-600 mx-auto"></div>
        </div>
      </section>
    );
  }

  const projects = [...content.portfolio].sort((a, b) => a.order - b.order);

  return (
    <section id="portfolio" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Nuestro Portafolio
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Proyectos exitosos que demuestran nuestra experiencia y dedicación
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project) => (
            <div
              key={project.id}
              className="group relative bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-all transform hover:-translate-y-2 cursor-pointer"
            >
              <div className="relative h-64 overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
                
                {project.link && project.link !== '#' && (
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                    <a
                      href={project.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="px-6 py-3 bg-white text-gray-900 rounded-full font-semibold hover:bg-blue-600 hover:text-white transition-colors whitespace-nowrap"
                    >
                      Ver Proyecto
                      <i className="ri-external-link-line ml-2 w-5 h-5 inline-flex items-center justify-center"></i>
                    </a>
                  </div>
                )}

                <div className="absolute top-4 right-4">
                  <span className="px-3 py-1 bg-blue-600 text-white text-xs font-semibold rounded-full">
                    {project.category}
                  </span>
                </div>
              </div>

              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  {project.title}
                </h3>
                <p className="text-gray-600 text-sm">
                  {project.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-flex items-center space-x-8 bg-gradient-to-r from-blue-50 to-purple-50 px-8 py-6 rounded-2xl">
            <div className="text-center">
              <div className="text-3xl font-bold text-gray-900 mb-1">{projects.length}+</div>
              <div className="text-gray-600 text-sm">Proyectos Destacados</div>
            </div>
            <div className="h-12 w-px bg-gray-300"></div>
            <div className="text-center">
              <div className="text-3xl font-bold text-gray-900 mb-1">100%</div>
              <div className="text-gray-600 text-sm">Satisfacción del Cliente</div>
            </div>
            <div className="h-12 w-px bg-gray-300"></div>
            <div className="text-center">
              <div className="text-3xl font-bold text-gray-900 mb-1">5★</div>
              <div className="text-gray-600 text-sm">Calificación Promedio</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
